import { render, staticRenderFns } from "./detailCash.vue?vue&type=template&id=b604a2b0&"
import script from "./detailCash.vue?vue&type=script&lang=js&"
export * from "./detailCash.vue?vue&type=script&lang=js&"
import style0 from "./detailCash.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports